import { Model } from '@/models/Model';

export class Rpc extends Model {
  protected $name = 'Rpc';

  protected $endpoint = '/rpc';

  protected $fillable: string[] = ['signature', 'body'];

  public signature?: string;

  public body?: any;

  public post(payload: RpcPayload): Promise<any> {
    const url = `${this.$endpoint}`;
    return this.request('post', url, payload);
  }
}

export interface RpcPayload {
  signature: string;
  body: {[key: string]: any};
}
